const applyDiscount = ({ value, discount }) => value - discount;

const calculateTotal = ({ quantity, unit_price, discount }) => {
  let newUnit = unit_price;

  const total = applyDiscount({ value: quantity * unit_price, discount });

  if (discount) {
    newUnit = total / quantity;
  }

  return {
    quantity, unit_price: newUnit, price: total, discount,
  };
};

const calculateUnit = ({
  quantity, price, discount, unit_price,
}) => {
  let newUnitPrice = unit_price;

  if (!discount) {
    newUnitPrice = price / quantity;
  }

  return {
    quantity, unit_price: newUnitPrice, price, discount,
  };
};

export const calculationStrategy = ({
  strategy, quantity, unit_price, price, discount = 0,
}) => {
  if (strategy === 'price') {
    return calculateUnit({
      quantity, price, discount, unit_price,
    });
  }

  if (strategy === 'unit_price') {
    return calculateTotal({ quantity, unit_price, discount });
  }

  return {
    quantity,
    unit_price,
    price: quantity * unit_price - discount,
    discount,
  };
};
